"use client";

import FreeConsultationForm from "./calendly-form";

export default function FreeConsultationModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-[560px] max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-0 right-0 z-20 h-10 w-10 rounded-full text-xl bg-white shadow"
        >
          ×
        </button>

        <FreeConsultationForm onSuccess={onClose} />
      </div>
    </div>
  );
}
